<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Contacts</span>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
            <div style="width: 100%;">
                <!-- Separated into components to keep the templates clean -->
                <tyl-contacts-v9 *ngIf="contacts.length > 0" [contacts]="contacts"></tyl-contacts-v9>
            </div>
        </div>
    </div>
</mat-card>
